import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes so later ones win instead of both being emitted. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
